'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = require('immutable');

var _BaseFilter = require('../base/BaseFilter');

var _BaseFilter2 = _interopRequireDefault(_BaseFilter);

var _WrapListFilter2 = require('./WrapListFilter');

var _WrapListFilter3 = _interopRequireDefault(_WrapListFilter2);

require('./list-select.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IDListSelect = function (_WrapListFilter) {
    (0, _inherits3.default)(IDListSelect, _WrapListFilter);

    function IDListSelect(props) {
        (0, _classCallCheck3.default)(this, IDListSelect);

        var _this = (0, _possibleConstructorReturn3.default)(this, (IDListSelect.__proto__ || (0, _getPrototypeOf2.default)(IDListSelect)).call(this, props));

        _this.state.value = props.value || (props.isMulti ? [] : null);
        _this.onItemClick = _this.onItemClick.bind(_this);
        _this.dataTestID = 'list';
        return _this;
    }

    (0, _createClass3.default)(IDListSelect, [{
        key: 'itemRenderer',
        value: function itemRenderer(_ref) {
            var _this2 = this;

            var index = _ref.index,
                style = _ref.style;
            var _props = this.props,
                itemRenderer = _props.itemRenderer,
                labelKey = _props.labelKey,
                valueKey = _props.valueKey,
                isMulti = _props.isMulti,
                showSelected = _props.showSelected;
            var _state = this.state,
                value = _state.value,
                options = _state.options;

            var isActive = isMulti ? (value || []).indexOf(options[index][valueKey]) >= 0 : value === options[index][valueKey];
            return _react2.default.createElement(
                'div',
                {
                    key: index,
                    style: style,
                    className: (0, _classnames2.default)('list-item', isActive && showSelected ? 'list-item-active' : ''),
                    onClick: function onClick() {
                        _this2.onItemClick(options[index]);
                    }
                },
                itemRenderer && itemRenderer(index, options, labelKey)
            );
        }
    }, {
        key: 'onItemClick',
        value: function onItemClick(data) {
            var _props2 = this.props,
                isMulti = _props2.isMulti,
                valueKey = _props2.valueKey;
            var value = this.state.value;

            if (isMulti) {
                var valueIndex = (value || []).indexOf(data[valueKey]);
                if (valueIndex < 0) {
                    value.push(data[valueKey]);
                } else {
                    value.splice(valueIndex, 1);
                }
                this.setState({ value: value });
            } else if (value !== data[valueKey]) {
                this.setState({ value: data[valueKey] });
            }
            this.props.onItemClick && this.props.onItemClick(data);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props3 = this.props,
                style = _props3.style,
                className = _props3.className,
                filter = _props3.filter,
                disabled = _props3.disabled,
                readOnly = _props3.readOnly;


            return _react2.default.createElement(
                'div',
                {
                    'data-testid': this.getDataTestId(),
                    ref: function ref(containerRef) {
                        _this3.containerRef = containerRef;
                    },
                    style: style,
                    className: (0, _classnames2.default)('list-wrap', 'body-wrap', className, {
                        'input-disabled': disabled,
                        'read-only': readOnly
                    })
                },
                _react2.default.createElement(
                    'div',
                    { className: 'base-filter list-filter' },
                    filter && this.renderFilter(),
                    this.renderComponent()
                )
            );
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
            var isValueChange = nextProps.isMulti ? !(0, _immutable.List)(prevState.prevProps.value || []).equals((0, _immutable.List)(nextProps.value || [])) : prevState.prevProps.value !== nextProps.value;

            var isOptionsChanged = !(0, _immutable.List)(prevState.prevProps.options || []).equals((0, _immutable.List)(nextProps.options || []));

            if (isValueChange || isOptionsChanged) {
                return {
                    prevProps: nextProps,
                    options: _BaseFilter2.default.filterString(nextProps.options, prevState.filterText, nextProps.filterProperties),
                    value: nextProps.value || (nextProps.isMulti ? [] : null)
                };
            }

            return null;
        }
    }]);
    return IDListSelect;
}(_WrapListFilter3.default);

IDListSelect.defaultProps = (0, _extends3.default)({}, _WrapListFilter3.default.defaultProps || {}, {
    maxItems: 10,
    showSelected: true,
    isMulti: false,
    labelKey: 'label',
    valueKey: 'value',
    itemRenderer: function itemRenderer(index, options, labelKey) {
        return options[index] && options[index][labelKey];
    },
    placeholder: "Search..."
});

exports.default = IDListSelect;